require("babel-polyfill");

const React = require("react");
const ReactDOM = require("react-dom");
const Provider = require("react-redux").Provider;
const ConnectToStore = require("react-redux").connect;

const store = require("./store.js");
const config = require("./config.js");
const router = require("./router.js");
const authenticator = require("./authenticator.js");
const autosaver = require("./autosaver.js");

const Root = ConnectToStore((state) => state)(
    require("./components/Root.jsx"));

if (window.location.protocol.indexOf("https") === -1
    && window.location.hostname !== "localhost") {
    window.location.protocol = "https";
}

authenticator.CheckForHashToken();
authenticator.WithToken(loadUi, authenticator.LogIn);

function loadUi() {
    let main = document.getElementById("Main");

    router.Start(store);
    autosaver.Start();

    ReactDOM.render((
        <Provider store={store}>
            <Root />
        </Provider>), main);
}


// WEBPACK FOOTER //
// ./src/start.jsx